import PropTypes from 'prop-types';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import currencyFormat from 'utils/currencyFormat';
import GraphNoData from '../../assets/images/graphNoData.png';
import './index.scss';
import RenderTooltip from './RenderTooltip';

function TopMerchantsBarChart({ barChartData, XaxisKey, YaxisKey, yAxislabel }) {
  const formatAmount = (value) => {
    let amountValue = currencyFormat(value, true, true);
    amountValue = amountValue ? amountValue.replace('₹', '') : 0;
    return amountValue;
  };
  return (
    <ResponsiveContainer className="top-merchants-container">
      {barChartData?.length > 0 ? (
        <BarChart
          width={100}
          height={100}
          data={barChartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20
          }}
          barSize={60}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <Bar dataKey={yAxislabel} fill="#6D44E5" />
          <XAxis
            dataKey="merchant_id"
            label={{
              value: XaxisKey,
              angle: -0,
              offset: -20,
              position: 'insideBottom',
              fill: 'black'
            }}
            stroke="black" // Axis line & tick color
            tick={{ fill: 'black' }} // Tick label styling
            axisLine={{ stroke: 'black' }} // Explicitly set axis line color
            tickLine={{ stroke: 'black' }} // Tick mark line color
          />
          <YAxis
            scale="log"
            label={{
              value: YaxisKey,
              angle: -90,
              position: 'outsideLeft',
              fontSize: 14,
              fill: 'black'
            }}
            domain={['dataMin', 'dataMax']}
            tickFormatter={formatAmount}
            tick={false}
            axisLine
            stroke="black" // Axis line & tick color
            tickLine={{ stroke: 'black' }} // Tick mark line color
          />
          <Tooltip cursor={false} content={RenderTooltip} />
        </BarChart>
      ) : (
        <div className="graph-no-data">
          <img src={GraphNoData} width="320px" height="170px" alt="Seems like no data" />
        </div>
      )}
    </ResponsiveContainer>
  );
}
TopMerchantsBarChart.propTypes = {
  barChartData: PropTypes.instanceOf(Array).isRequired,
  XaxisKey: PropTypes.string.isRequired,
  YaxisKey: PropTypes.string.isRequired,
  yAxislabel: PropTypes.string.isRequired
};
export default TopMerchantsBarChart;
